exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "team-requests{display:block}@media only screen and (device-width:375px)and (device-height:812px)and (-webkit-device-pixel-ratio:3){team-requests{padding-bottom:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamRequests/teamRequests.scss
// module id = 1174
// module chunks = 0